export const AUTO = 'auto';
export const PROGRESS = 'progress';

export const changeCursor = (type = AUTO) => {
	window.document.body.style.cursor = type;
};


// WEBPACK FOOTER //
// ./src/utils/cursor.js